import { useEffect, useRef, useSyncExternalStore } from 'react';
import { useToast } from '@maat/ds-core';
import { bustedReload } from '@maat/store-error';
import { useTranslation } from '@maat/store-i18n';
import { reloadRequiredStore } from './reloadRequiredStore';

/**
 * A persistent, NON-blocking toast when the backend reports this client below the
 * minimum build — people keep working and reload when ready, rather than meeting a
 * modal. Fires once; the store latches.
 */
export const ReloadRequiredToast = () => {
    const { toast } = useToast();
    const { t } = useTranslation('common');
    const required = useSyncExternalStore(
        reloadRequiredStore.subscribe,
        reloadRequiredStore.getSnapshot,
        () => false, // server snapshot (SSR/native): never
    );
    const shown = useRef(false);

    useEffect(() => {
        if (!required || shown.current) return;
        shown.current = true;
        toast({
            title: t('appUpdate.requiredTitle'),
            description: t('appUpdate.requiredDescription'),
            variant: 'warning',
            duration: Infinity, // persists until the user reloads
            // Cache-busted: a client old enough to be below the minimum build may
            // hold immutable-poisoned entries a plain reload would re-serve.
            action: { label: t('appUpdate.reload'), onClick: () => bustedReload() },
        });
    }, [required, toast, t]);

    return null;
};
